import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/base/sheet";

import { FlagList } from "./FlagList";
import { OverlaySection } from "./OverlaySection";
import { useDebugContext } from "./use_debug_context";

/** Which flags this merchant resolves to, and where the device disagrees. */
export function FlagsSheet({
  open,
  onOpenChange,
  businessId,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  businessId: string;
}) {
  const { context, error, loading } = useDebugContext(businessId, open);
  const flagState = context?.flagState ?? null;
  // A source that failed before returning is not "no assignments".
  const failed = context?.partialSources.includes("flags") ?? false;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="right" className="w-full gap-0 p-0 sm:max-w-[563px]">
        <SheetHeader className="border-border border-b px-6 py-4">
          <SheetTitle className="text-foreground text-lg font-semibold">
            Flags
          </SheetTitle>
        </SheetHeader>

        <div className="overflow-y-auto">
          <OverlaySection title="Resolved for this merchant">
            {error ? (
              <p className="text-sm text-red-600">Could not load: {error}</p>
            ) : loading ? (
              <p className="text-subtle-foreground text-sm">Loading…</p>
            ) : flagState?.unavailable || failed ? (
              <p className="text-sm text-amber-700">
                Amplitude could not be read — this is not &ldquo;no
                flags&rdquo;.
              </p>
            ) : flagState && flagState.flags.length > 0 ? (
              <FlagList
                flags={flagState.flags}
                deviceReportedAt={flagState.deviceReportedAt}
              />
            ) : (
              <p className="text-muted-foreground text-sm">
                No flag assignments.
              </p>
            )}
          </OverlaySection>
        </div>
      </SheetContent>
    </Sheet>
  );
}
